module.exports = __webpack_public_path__ + "img/imgNonProfile.7530d504.png";